import template from './template-block.html';
import controller from './template-block.controller';
import './template-block.scss';

let templateBlockComponent = {
  bindings: {
    templateBlock: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default templateBlockComponent;



// WEBPACK FOOTER //
// ./client/app/components/template-block/template-block.component.js